module.exports = __webpack_public_path__ + "img/earn-count-bg.b4acebe8.jpg";